export default __webpack_public_path__ + "static/e-team-1f4411b9c2a1631b6be0d1fc224fd4e3.png";